import { inject, observer } from "mobx-react";
import { fn_delivery_call, fn_delivery_cancel } from "function/FnBodyStep";
import { fn_orderDetailBaemin, fn_connectFailBaemin } from "function/FnBodyLayer";
import { fn_orderEndDetail } from "function/FnBodyDetail";
import { fn_bridge_order_detail_baemin } from "function/FnPosBridge";
import { baerminUseYn, baeminUsePosNo } from "utils/Utils";
import { MobileOrderFg } from "types";

const BaeminOrderCardButtonViewCase = ({ rootStore, order, searchStore }) => {
  let checkCallBack =
    order.mobileOrderFg === MobileOrderFg.BAEMIN_ONE || order.mobileOrderFg === MobileOrderFg.BAEMIN_STORE;
  let detailType = "";
  let empty = false;

  if (
    (searchStore.getCurrStepType === "all" && order.stepType === "READY") ||
    searchStore.getCurrStepType === "ready"
  ) {
    detailType = "ready";
  } else if (
    (searchStore.getCurrStepType === "all" && order.stepType === "COOKING") ||
    searchStore.getCurrStepType === "cooking"
  ) {
    detailType = "cooking";
  } else if (
    (searchStore.getCurrStepType === "all" && order.stepType === "DELIVERY") ||
    searchStore.getCurrStepType === "delivery"
  ) {
    if ((order.dlvStatusFg === null || order.dlvStatusFg === "99") && order.stepCd === "500") {
      detailType = "cooking";
    } else {
      detailType = "delivery";
    }
  }

  function onClickActionBtnLeft() {
    if (detailType === "cooking") {
      baerminUseYn(rootStore)
        ? baeminUsePosNo(rootStore)
          ? fn_bridge_order_detail_baemin(rootStore, order)
          : fn_orderDetailBaemin(rootStore)
        : fn_connectFailBaemin(rootStore, "baemin_connect_fail_cancel", order); //거절
    } else if (detailType === "delivery") {
      if (order.orderType === "DELIVERY") {
        (!order.dlvStatusFg || order.dlvStatusFg === "00") && order.mobileOrderFg === MobileOrderFg.BAEMIN
          ? fn_delivery_cancel(rootStore, order)
          : baerminUseYn(rootStore)
          ? baeminUsePosNo(rootStore)
            ? fn_bridge_order_detail_baemin(rootStore, order)
            : fn_orderDetailBaemin(rootStore)
          : fn_connectFailBaemin(rootStore, "baemin_connect_fail_cancel", order);
      } else {
        baerminUseYn(rootStore)
          ? baeminUsePosNo(rootStore)
            ? fn_bridge_order_detail_baemin(rootStore, order)
            : fn_orderDetailBaemin(rootStore)
          : fn_connectFailBaemin(rootStore, "baemin_connect_fail_cancel", order); //거절
      }
    }
  }

  function onClickActionBtnRight() {
    if (detailType === "ready") {
      baerminUseYn(rootStore)
        ? baeminUsePosNo(rootStore)
          ? fn_bridge_order_detail_baemin(rootStore, order)
          : fn_orderDetailBaemin(rootStore)
        : fn_connectFailBaemin(rootStore, "baemin_connect_fail_accept", order); //수락
    } else if (detailType === "cooking") {
      if (order.orderType === "DELIVERY") {
        if (order.mobileOrderFg === "28" && order.morderTypeCd == "D") {
          fn_delivery_call(rootStore, order.mobileOrderNo, "riderCallDetail Button");
        } else {
          baerminUseYn(rootStore)
            ? baeminUsePosNo(rootStore)
              ? fn_bridge_order_detail_baemin(rootStore, order)
              : fn_orderDetailBaemin(rootStore)
            : fn_connectFailBaemin(rootStore, "baemin_connect_fail_pickupCall", order); //호출
        }
      } else if (order.orderType === "PICKUP") {
        baerminUseYn(rootStore)
          ? baeminUsePosNo(rootStore)
            ? fn_bridge_order_detail_baemin(rootStore, order)
            : fn_orderDetailBaemin(rootStore)
          : fn_connectFailBaemin(rootStore, "baemin_connect_fail_pickupCall", order); //호출
      } else {
        fn_bridge_order_detail_baemin(rootStore, order);
      }
    } else if (detailType === "delivery") {
      baerminUseYn(rootStore)
        ? baeminUsePosNo(rootStore)
          ? fn_bridge_order_detail_baemin(rootStore, order)
          : fn_orderDetailBaemin(rootStore)
        : fn_connectFailBaemin(
            rootStore,
            checkCallBack ? "baemin_connect_fail_ready" : "baemin_connect_fail_complete",
            order
          ); //준비완료,배달완료
    } else if (order.stepCd == "700" || order.stepCd == "900") {
      fn_orderEndDetail(rootStore, order.mobileOrderNo, "endOrderView");
    }
  }

  function btnTypeTxtLeft() {
    let txt = "";
    let cls = "c";
    if (detailType === "ready") {
      empty = true;
    } else if (detailType === "cooking") {
      if (order.orderType === "DELIVERY") {
        empty = true;
      } else {
        cls = "s";
        txt = "호출";
      }
    } else if (detailType === "delivery") {
      if (order.orderType === "DELIVERY") {
        empty = true;
      } else {
        //txt = "재호출"
        txt = "주문취소";
      }
    } else if (order.stepCd == "700") {
      empty = true;
    } else if (order.stepCd == "900") {
      empty = true;
    }

    if (empty != true) {
      return (
        <span>
          <button type="button" className={cls} onClick={() => onClickActionBtnLeft()}>
            {txt}
          </button>
        </span>
      );
    }
  }

  function btnTypeTxtRight() {
    let txt = "";
    if (detailType === "ready") {
      txt = "주문접수";
    } else if (detailType === "cooking") {
      if (order.orderType === "DELIVERY") {
        checkCallBack ? (txt = "준비완료") : (txt = "배달요청");
      } else {
        txt = "픽업완료";
      }
    } else if (detailType === "delivery") {
      if (order.orderType === "DELIVERY") {
        checkCallBack ? (txt = "준비완료") : (txt = "배달완료");
      } else {
        txt = "호출";
      }
    }

    return txt;
  }

  function btnClass() {
    let color = "";
    
    if (order.stepCd == "700") {
      color = "end";
    } else if (order.stepCd == "900") {
      color = "cancel";
    }

    if (detailType === "ready") {
      color = "s";
    } else if (detailType === "cooking") {
      if (order.orderType === "DELIVERY") {
        checkCallBack ? (color = "complete") : (color = "s");
      } else {
        color = "complete";
      }
    } else if (detailType === "delivery") {
      if (order.orderType === "DELIVERY") {
        order.mobileOrderFg === "29" && order.partnerEtcInfo != "COOK_COMPLETED"
          ? (color = "s")
          : order.mobileOrderFg === "30" && order.morderTypeCd == "D"
          ? (color = "s")
          : (color = "complete");
      } else {
        color = "s";
      }
    }

    return color;
  }

  function btnEnd() {
    let end_txt = "";
    if (order.stepCd == "700") {
      end_txt = "완료주문";
    } else if (order.stepCd == "900") {
      end_txt = "취소주문";
    }
    return end_txt;
  }

  return (
    <span className="btns">
      <span className="inner">
        {btnTypeTxtLeft()}
        <span>
          <button type="button" className={btnClass()} onClick={() => onClickActionBtnRight()}>
            {order.stepCd == "700" || order.stepCd == "900" ? (
              <>
                <span className="btn_end">{btnEnd()}</span>
              </>
            ) : (
              <span className={order.partnerEtcInfo == "COOK_COMPLETED" ? "checkTxt" : ""}>{btnTypeTxtRight()}</span>
            )}
            {order.partnerEtcInfo == "COOK_COMPLETED" && !(order.stepCd == "700" || order.stepCd == "900") ? (
              <span className="checkIco"></span>
            ) : null}
          </button>
        </span>
      </span>
    </span>
  );
};
// }

export default inject("rootStore")(observer(BaeminOrderCardButtonViewCase));
